import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import injectReducer from 'utils/injectReducer';
import { makeSelectStep16 } from './selectors';
import reducer from './reducer';
import PageSectionHeader from '../components/PageSectionHeader';
import Textbox from '../components/Textbox';
import DatePicker from '../components/DatePicker';
import TextArea from '../components/TextArea';
import HelpText from '../../../components/HelpText';
import messages from './messages';
import {
  handleFormDataChange,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import { Button } from '../components/Button';
import { saveFormData } from '../actions';
import { required } from '../../../utils/validation/validator';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation/';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { makeSelectCurrentStep } from '../../Wizard/selectors';

class Step16 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };

    this.validatorGroup = new ValidateGroup();
    this.saveButtonId = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;

    this.onResize = this.onResize.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }
  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  handleChange = (propertyName) => (event) => {   
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
  };

  handleChangeNameOfDeceased = (propertyName) => (event) => { 
    const { checkNameOfDeceased } = this.props.form;
    const checkNameOfDeceases = !!checkNameOfDeceased && typeof checkNameOfDeceased.toJS === 'function'
    ? checkNameOfDeceased.toJS()
    : checkNameOfDeceased || [];

    const listChecked = _.cloneDeep(checkNameOfDeceases);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    this.checkFormError();

    this.props.onFormDataSave();
    this.props.next();
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  render() {
    const { isSummary, submitted, loading } = this.props;

    const {
      nameOfDeceased,
      dateOfInjury,
      theClaimIsBeingMadeUnder,
      placeWhereAccidentHappened,
      describeWhereTheAccidentOccurred,
      describeHowTheAccidentOccurred,
      checkNameOfDeceased,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    const checkNameOfDeceases = !!checkNameOfDeceased && typeof checkNameOfDeceased.toJS === 'function'
    ? checkNameOfDeceased.toJS()
    : checkNameOfDeceased || [];

    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <Validate
              name="nameOfDeceased"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={nameOfDeceased}
              fieldName={messages.nameOfDeceased}
            >
              <Textbox
                name="nameOfDeceased"
                type="text"
                disabled={isReadOnly}
                onChange={this.handleChange('form.nameOfDeceased')}
                value={nameOfDeceased}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.nameOfDeceased}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.theClaimIsBeingMadeUnder} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Accidental Death"
                  checked={theClaimIsBeingMadeUnder === 'Accidental Death'}
                  onChange={this.handleChange('form.theClaimIsBeingMadeUnder')}
                />
                <FormattedMessage {...messages.accidentalDeath} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Accidental Dismemberment"
                  checked={theClaimIsBeingMadeUnder === 'Accidental Dismemberment'}
                  onChange={this.handleChange('form.theClaimIsBeingMadeUnder')}
                />
                <FormattedMessage {...messages.accidentalDismemberment} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateOfInjury} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateOfInjury"
              type="text"
              onDayChange={this.handleDayChange('form.dateOfInjury')}
              value={dateOfInjury}
            />
            <div className={'row'}></div>
            <Validate
              name="placeWhereAccidentHappened"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={placeWhereAccidentHappened}
              fieldName={messages.placeWhereAccidentHappened}  
            >
              <Textbox
                name="placeWhereAccidentHappened"
                type="text"
                disabled={isReadOnly}
                onChange={this.handleChange('form.placeWhereAccidentHappened')}
                value={placeWhereAccidentHappened}   
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.placeWhereAccidentHappened}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'form-group col-sm-6'}>
            <Validate
              name="checkNameOfDeceased"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={checkNameOfDeceases}
              fieldName={messages.checkNameOfDeceased}
            >
              <div className={'row'}>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Right Hand"
                    checked={checkNameOfDeceases.includes('Right Hand')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.rightHand} />
                  </span>  
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Both Feet"
                    checked={checkNameOfDeceases.includes('Both Feet')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.bothFeet} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Left Hand"
                    checked={checkNameOfDeceases.includes('Left Hand')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.leftHand} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Sight of Right Eye"
                    checked={checkNameOfDeceases.includes('Sight of Right Eye')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.sightOfRightEye} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Both Hands"
                    checked={checkNameOfDeceases.includes('Both Hands')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.bothHands} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Sight of Left Eye"
                    checked={checkNameOfDeceases.includes('Sight of Left Eye')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.sightOfLeftEye} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Right Foot"
                    checked={checkNameOfDeceases.includes('Right Foot')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.rightFoot} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Sight Of Both Eyes"
                    checked={checkNameOfDeceases.includes('Sight Of Both Eyes')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.sightOfBothEyes} />
                  </span>
                </div>
                <div className={'form-group col-sm-6'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Left Foot"
                    checked={checkNameOfDeceases.includes('Left Foot')}
                    onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                  />
                  <span>
                    <FormattedMessage {...messages.leftFoot} />
                  </span>
                </div>
              </div>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.checkNameOfDeceased}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-12'}>
            <Validate
              name="describeWhereTheAccidentOccurred"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={describeWhereTheAccidentOccurred}
              fieldName={messages.describeWhereTheAccidentOccurred}
            >
              <TextArea
                disabled={isReadOnly}
                name="describeWhereTheAccidentOccurred"
                type="text"
                onChange={this.handleChange('form.describeWhereTheAccidentOccurred')}
                value={describeWhereTheAccidentOccurred}
                isSummary={isSummary}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.describeWhereTheAccidentOccurred}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-12'}>
            <Validate
              name="describeHowTheAccidentOccurred"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={describeHowTheAccidentOccurred}
              fieldName={messages.describeHowTheAccidentOccurred}
            >
              <TextArea
                disabled={isReadOnly}
                name="describeHowTheAccidentOccurred"
                type="text"
                onChange={this.handleChange('form.describeHowTheAccidentOccurred')}
                value={describeHowTheAccidentOccurred}
                isSummary={isSummary}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.describeHowTheAccidentOccurred}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-7'}>
            <HelpText>
            On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
            </HelpText>
          </div>
          <div className={'form-group col-sm-5'}>
            <Button>
              Statement of Attending Physician
            </Button>
          </div>
        </div>
        {!isSummary && (
          <div className={'row justify-content-between mt-3'}>
            <div className={'col'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            {!submitted && (
              <div className={'col-12 col-sm-auto'}>
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onKeyDown={this.handleKeyDown}
                  onClick={this.handleSaveButtonClick}
                >
                  Save
                </AsyncButton>
              </div>
            )}
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

Step16.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  next: PropTypes.func,
  prev: PropTypes.func,
  onFormDataSave: PropTypes.func,
  adjust: PropTypes.func,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  loading: PropTypes.bool,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  errors: PropTypes.any,
  isReadOnly: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStep16(),
  loading: makeSelectProgressBarStatus(),
  currentStep: makeSelectCurrentStep(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'step16', reducer });

export default compose(
  withReducer,
  withConnect
)(Step16);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step16/index.js